import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  TextField,
  CssBaseline,
  Link,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AmplifyAuthenticator } from "@aws-amplify/ui-react";
import QrReader from "react-qr-reader";
//redux, global hooks/state
import {useSelector,useDispatch} from 'react-redux' //get from redux 
import  {rxShowAmplifyAuth}  from "../features/auth"; //set redux for auth
import  {rxLoginUsername}  from "../features/loginUsername"; //set redux username
import  {rxLoginPassword}  from "../features/loginPassword"; //set redux password

const theme = createTheme();
let logo_click = 0;
const Login = (props) => {
  const [dialogQROpen, setDialogQROpen] = useState(false);
  //const fascia = useSelector((state)=>state.fascia.value)
  const dispatch = useDispatch();
  const loginUsername = useSelector((state)=>state.loginUsername.value)
  const loginPassword = useSelector((state)=>state.loginPassword.value)


  const handleLogInUsernameChange = (event) => {
    //props.setLoginUserName(event.target.value);
    dispatch(rxLoginUsername(event.target.value));
  };
  const handleLogInPasswordChange = (event) => {
    //props.setLoginPassword(event.target.value);
    dispatch(rxLoginPassword(event.target.value));
  };
  const handleLogIn = () => {
    props.handleSignIn(loginUsername,loginPassword);
  };

  const handleLogoClick = () => {
    logo_click++;
    if (logo_click > 10) {
      //props.setShowAmplifyAuth(true);
      dispatch(rxShowAmplifyAuth(true));
    }
  };

  const handleScan = (data) => {
    if (data !== null) {
      if (data.indexOf("https://") > -1) {
        var snd = new Audio(
          "data:audio/wav;base64,//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+QWaAAihwMWm4G8QQRDiMcCBcH3Cc+CDv/7xA4Tvh9Rz/y8QADBwMWgQAZG/ILNAARQ4GLTcDeIIIhxGOBAuD7hOfBB3/94gcJ3w+o5/5eIAIAAAVwWgQAVQ2ORaIQwEMAJiDg95G4nQL7mQVWI6GwRcfsZAcsKkJvxgxEjzFUgfHoSQ9Qq7KNwqHwuB13MA4a1q/DmBrHgPcmjiGoh//EwC5nGPEmS4RcfkVKOhJf+WOgoxJclFz3kgn//dBA+ya1GhurNn8zb//9NNutNuhz31f////9vt///z+IdAEAAAK4LQIAKobHItEIYCGAExBwe8jcToF9zIKrEdDYIuP2MgOWFSE34wYiR5iqQPj0JIeoVdlG4VD4XA67mAcNa1fhzA1jwHuTRxDUQ//iYBczjHiTJcIuPyKlHQkv/LHQUYkuSi57yQT//uggfZNajQ3Vmz+Zt//+mm3Wm3Q576v////+32///5/EOgAAADVghQAAAAA//uQZAUAB1WI0PZugAAAAAoQwAAAEk3nRd2qAAAAACiDgAAAAAAABCqEEQRLCgwpBGMlJkIz8jKhGvj4k6jzRnqasNKIeoh5gI7BJaC1A1AoNBjJgbyApVS4IDlZgDU5WUAxEKDNmmALHzZp0Fkz1FMTmGFl1FMEyodIavcCAUHDWrKAIA4aa2oCgILEBupZgHvAhEBcZ6joQBxS76AgccrFlczBvKLC0QI2cBoCFvfTDAo7eoOQInqDPBtvrDEZBNYN5xwNwxQRfw8ZQ5wQVLvO8OYU+mHvFLlDh05Mdg7BT6YrRPpCBznMB2r//xKJjyyOh+cImr2/4doscwD6neZjuZR4AgAABYAAAABy1xcdQtxYBYYZdifkUDgzzXaXn98Z0oi9ILU5mBjFANmRwlVJ3/6jYDAmxaiDG3/6xjQQCCKkRb/6kg/wW+kSJ5//rLobkLSiKmqP/0ikJuDaSaSf/6JiLYLEYnW/+kXg1WRVJL/9EmQ1YZIsv/6Qzwy5qk7/+tEU0nkls3/zIUMPKNX/6yZLf+kFgAfgGyLFAUwY//uQZAUABcd5UiNPVXAAAApAAAAAE0VZQKw9ISAAACgAAAAAVQIygIElVrFkBS+Jhi+EAuu+lKAkYUEIsmEAEoMeDmCETMvfSHTGkF5RWH7kz/ESHWPAq/kcCRhqBtMdokPdM7vil7RG98A2sc7zO6ZvTdM7pmOUAZTnJW+NXxqmd41dqJ6mLTXxrPpnV8avaIf5SvL7pndPvPpndJR9Kuu8fePvuiuhorgWjp7Mf/PRjxcFCPDkW31srioCExivv9lcwKEaHsf/7ow2Fl1T/9RkXgEhYElAoCLFtMArxwivDJJ+bR1HTKJdlEoTELCIqgEwVGSQ+hIm0NbK8WXcTEI0UPoa2NbG4y2K00JEWbZavJXkYaqo9CRHS55FcZTjKEk3NKoCYUnSQ0rWxrZbFKbKIhOKPZe1cJKzZSaQrIyULHDZmV5K4xySsDRKWOruanGtjLJXFEmwaIbDLX0hIPBUQPVFVkQkDoUNfSoDgQGKPekoxeGzA4DUvnn4bxzcZrtJyipKfPNy5w+9lnXwgqsiyHNeSVpemw4bWb9psYeq//uQZBoABQt4yMVxYAIAAAkQoAAAHvYpL5m6AAgAACXDAAAAD59jblTirQe9upFsmZbpMudy7Lz1X1DYsxOOSWpfPqNX2WqktK0DMvuGwlbNj44TleLPQ+Gsfb+GOWOKJoIrWb3cIMeeON6lz2umTqMXV8Mj30yWPpjoSa9ujK8SyeJP5y5mOW1D6hvLepeveEAEDo0mgCRClOEgANv3B9a6fikgUSu/DmAMATrGx7nng5p5iimPNZsfQLYB2sDLIkzRKZOHGAaUyDcpFBSLG9MCQALgAIgQs2YunOszLSAyQYPVC2YdGGeHD2dTdJk1pAHGAWDjnkcLKFymS3RQZTInzySoBwMG0QueC3gMsCEYxUqlrcxK6k1LQQcsmyYeQPdC2YfuGPASCBkcVMQQqpVJshui1tkXQJQV0OXGAZMXSOEEBRirXbVRQW7ugq7IM7rPWSZyDlM3IuNEkxzCOJ0ny2ThNkyRai1b6ev//3dzNGzNb//4uAvHT5sURcZCFcuKLhOFs8mLAAEAt4UWAAIABAAAAAB4qbHo0tIjVkUU//uQZAwABfSFz3ZqQAAAAAngwAAAE1HjMp2qAAAAACZDgAAAD5UkTE1UgZEUExqYynN1qZvqIOREEFmBcJQkwdxiFtw0qEOkGYfRDifBui9MQg4QAHAqWtAWHoCxu1Yf4VfWLPIM2mHDFsbQEVGwyqQoQcwnfHeIkNt9YnkiaS1oizycqJrx4KOQjahZxWbcZgztj2c49nKmkId44S71j0c8eV9yDK6uPRzx5X18eDvjvQ6yKo9ZSS6l//8elePK/Lf//IInrOF/FvDoADYAGBMGb7FtErm5MXMlmPAJQVgWta7Zx2go+8xJ0UiCb8LHHdftWyLJE0QIAIsI+UbXu67dZMjmgDGCGl1H+vpF4NSDckSIkk7Vd+sxEhBQMRU8j/12UIRhzSaUdQ+rQU5kGeFxm+hb1oh6pWWmv3uvmReDl0UnvtapVaIzo1jZbf/pD6ElLqSX+rUmOQNpJFa/r+sa4e/pBlAABoAAAAA3CUgShLdGIxsY7AUABPRrgCABdDuQ5GC7DqPQCgbbJUAoRSUj+NIEig0YfyWUho1VBBBA//uQZB4ABZx5zfMakeAAAAmwAAAAF5F3P0w9GtAAACfAAAAAwLhMDmAYWMgVEG1U0FIGCBgXBXAtfMH10000EEEEEECUBYln03TTTdNBDZopopYvrTTdNa325mImNg3TTPV9q3pmY0xoO6bv3r00y+IDGid/9aaaZTGMuj9mpu9Mpio1dXrr5HERTZSmqU36A3CumzN/9Robv/Xx4v9ijkSRSNLQhAWumap82WRSBUqXStV/YcS+XVLnSS+WLDroqArFkMEsAS+eWmrUzrO0oEmE40RlMZ5+ODIkAyKAGUwZ3mVKmcamcJnMW26MRPgUw6j+LkhyHGVGYjSUUKNpuJUQoOIAyDvEyG8S5yfK6dhZc0Tx1KI/gviKL6qvvFs1+bWtaz58uUNnryq6kt5RzOCkPWlVqVX2a/EEBUdU1KrXLf40GoiiFXK///qpoiDXrOgqDR38JB0bw7SoL+ZB9o1RCkQjQ2CBYZKd/+VJxZRRZlqSkKiws0WFxUyCwsKiMy7hUVFhIaCrNQsKkTIsLivwKKigsj8XYlwt/WKi2N4d//uQRCSAAjURNIHpMZBGYiaQPSYyAAABLAAAAAAAACWAAAAApUF/Mg+0aohSIRobBAsMlO//Kk4soosy1JSFRYWaLC4qZBYWFRGZdwqKiwkNBVmoWFSJkWFxX4FFRQWR+LsS4W/rFRb/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////VEFHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU291bmRib3kuZGUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAwNGh0dHA6Ly93d3cuc291bmRib3kuZGUAAAAAAAAAACU="
        );
        snd.play();
        setDialogQROpen(false);
        window.location.replace(data);
      }
    }
  };
  const handleScanError = (err) => {
    console.error(err);
  };

  return (
    <div>
      <div style={{ display: "none" }}>
        <AmplifyAuthenticator />
      </div>
      <ThemeProvider theme={theme}>
        <Container id="welcome_container" component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 100,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              alt={""}
              src={process.env.PUBLIC_URL + "/assets/logos/booker.png"}
              onClick={() => handleLogoClick()}
            />
            <Typography id="welcome_text" component="h1" variant="h5">
              Trade Show Attendee Sign In
            </Typography>
            <Box noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="email"
                autoComplete="email"
                autoFocus
                value={loginUsername}
                onChange={handleLogInUsernameChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={loginPassword}
                onChange={handleLogInPasswordChange}
              />

              <Button
                id="sign_in_button"
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleLogIn()}
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <br></br>
              <br></br>
              <Button
                id="qr_button"
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                onClick={() => setDialogQROpen(true)}
                sx={{ mt: 3, mb: 2 }}
              >
                QR Code Sign In
              </Button>
              <Dialog aria-labelledby="job-confirm-title" open={dialogQROpen}>
                <DialogContent>
                  <DialogContentText>
                    Scan QR Code To View Deals
                  </DialogContentText>
                  <QrReader
                    ref={props.qrRef}
                    delay={1000}
                    onError={handleScanError}
                    onScan={handleScan}
                    style={{ width: "100%" }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setDialogQROpen(false);
                      props.qrRef.current.stopCamera();
                    }}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Box>
          <br></br>
          <Typography variant="body2" align="center">
            {"Copyright © "}
            <Link color="inherit" href="https://www.zedware.co.uk/">
              Zedware Limited
            </Link>{" "}
            {new Date().getFullYear()}
            {" All Rights Reserved"}
          </Typography>
        </Container>
      </ThemeProvider>
    </div>
  );
};
export default Login;
